<!--
  Created by:Pramod Kumar Reddy
  Created on: 26-Jul-2019 1:00 PM
  Purpose: To change  new password
-->
<div mat-dialog-title>
  Change Password
  <span class="float-right" (click)="cancel()">
    <i class="fa fa-times"></i>
  </span>
</div>
<div mat-dialog-content>
  <div class="form-group mb-4">
    <form [formGroup]="change_password_form">
      <mat-form-field floatLabel="always">
        <mat-label>{{'FORGOT_PASSWORD.oldPassword' |translate}}</mat-label>
        <input type="password" [type]="!current_hide ? 'password' : 'text'" class="w-93" matInput placeholder="Password"
          formControlName="oldPassword" [required]="true">
        <mat-icon matSuffix (click)="current_hide = !current_hide">{{!current_hide ? 'visibility_off' : 'visibility'}}
        </mat-icon>
        <mat-error *ngIf="change_password_form.controls.oldPassword.errors">
          <div ngClass="fval.password.errors.required"
            *ngIf="change_password_form.controls.oldPassword.errors.required; else minLength">
            {{'ERROR.password_is_required' | translate}}
          </div>
          <ng-template #minLength>
            <div *ngIf="change_password_form.controls.oldPassword.errors.minlength;else invalid_input">
              {{'ERROR.password_must_be_at_least_6_characters' | translate}}
            </div>
          </ng-template>
          <ng-template #invalid_input>
            <div *ngIf="change_password_form.controls.oldPassword.errors?.pattern">
              {{"ERROR.password_input_invalid" |translate}}
            </div>
          </ng-template>
        </mat-error>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label> {{'FORGOT_PASSWORD.newPassword' |translate}}</mat-label>
        <input type="password" [type]="!new_hide ? 'password' : 'text'" class="w-93" matInput placeholder="Password"
          formControlName="newPassword" [required]="true">
        <mat-icon matSuffix (click)="new_hide = !new_hide">{{!new_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error *ngIf="change_password_form.controls.newPassword.errors">
          <div ngClass="fval.password.errors.required"
            *ngIf="change_password_form.controls.newPassword.errors.required; else minLength">
            {{'ERROR.password_is_required' | translate}}
          </div>
          <ng-template #minLength>
            <div *ngIf="change_password_form.controls.newPassword.errors.minlength;else invalid_input">
              {{'ERROR.password_must_be_at_least_6_characters' | translate}}
            </div>
          </ng-template>
          <ng-template #invalid_input>
            <div *ngIf="change_password_form.controls.newPassword.errors?.pattern">
              {{"ERROR.password_input_invalid" |translate}}
            </div>
          </ng-template>
        </mat-error>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>Re-enter Password</mat-label>
        <input type="password" [type]="!re_enter_hide ? 'password' : 'text'" class="w-93" matInput
          placeholder="Password" formControlName="reenter_password" [required]="true">
        <mat-icon matSuffix (click)="re_enter_hide = !re_enter_hide">{{!re_enter_hide ? 'visibility_off' :
          'visibility'}}</mat-icon>
        <mat-error *ngIf="change_password_form.controls.reenter_password.errors">
          <div *ngIf="change_password_form.controls.reenter_password.errors.required ;else minLength1">
            {{'ERROR.re-enter_password_required' | translate}}
          </div>
          <ng-template #minLength1>
            <div *ngIf="change_password_form.controls.reenter_password.errors.minlength;else checkForInvalid">
              {{'ERROR.password_must_be_at_least_6_characters' | translate}}
            </div>
          </ng-template>
          <ng-template #checkForInvalid>
            <div *ngIf="change_password_form.controls.reenter_password.errors?.pattern;else mismatched">
              {{"ERROR.password_input_invalid" |translate}}
            </div>
          </ng-template>
          <ng-template #mismatched>
            <div *ngIf="change_password_form.controls.reenter_password.errors?.notSame">
              {{'ERROR.password_mismatch' | translate}}
            </div>
          </ng-template>

        </mat-error>
      </mat-form-field>
    </form>
  </div>
</div>
<div mat-dialog-actions *ngIf="!flag">
  <button class="ml-auto blob-btn-cancel btn mx-1" style="min-width: 120px;" (click)="cancel()">
    {{"BTN.close"|translate}}
    <span class="blob-btn-cancel__inner">
      <span class="blob-btn-cancel__blobs">
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
      </span>
    </span>
  </button>
  <button class="blob-btn btn " style="min-width: 120px;" type="submit" (click)="save()">
    {{"BTN.submit" |translate}}
    <span class="blob-btn__inner">
      <span class="blob-btn__blobs">
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
      </span>
    </span>
  </button>

</div>
